var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWithdrawWithBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 20a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V24h16v-3.5a.5.5 0 0 1 .5-.5h1zm-13.64-6.156l-.712-.713a.504.504 0 0 1 0-.713l4.278-4.279c.08-.081.23-.127.447-.139h.255c.216.012.365.058.446.139l4.279 4.279a.506.506 0 0 1 0 .713l-.714.713a.504.504 0 0 1-.713 0L19 11.418v8.074a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-8.074l-2.426 2.426a.504.504 0 0 1-.713 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    fillRule: "nonzero",
    d: "M18 36C8.059 36 0 27.941 0 18S8.059 0 18 0s18 8.059 18 18-8.059 18-18 18zm0-1.846c8.922 0 16.154-7.232 16.154-16.154S26.922 1.846 18 1.846 1.846 9.078 1.846 18 9.078 34.154 18 34.154z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdrawWithBorder);
export default __webpack_public_path__ + "static/media/icon-withdraw-with-border.1ef17a18ae0ef2442c50a6d8e97e7a47.svg";
export { ForwardRef as ReactComponent };